/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `offering` - Offering
* `admin` - Admin
 */
export type BenefitSourceEnum = typeof BenefitSourceEnum[keyof typeof BenefitSourceEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BenefitSourceEnum = {
  offering: 'offering',
  admin: 'admin',
} as const;
